module.exports = __webpack_public_path__ + "img/spitter-die-4.8cb1af95.png";